// Shared cache validation helper
// Determines if a value is valid for caching
// Rules:
// - Reject null/undefined
// - Reject empty arrays
// - Reject empty objects
// - Allow primitives including false, 0, and empty string
export function isValidDataForCaching(data) {
  if (data === null || data === undefined) return false;

  if (Array.isArray(data) && data.length === 0) return false;

  if (
    typeof data === 'object' &&
    !Array.isArray(data) &&
    Object.keys(data).length === 0
  )
    return false;

  return true;
}

export default isValidDataForCaching;
